let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("exjK0")).then(() => parcelRequire('3japI'));